import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import cx from 'classnames';

import { useLayout } from 'lib/common/contexts/layout/LayoutContext';

import { DatePicker, TimePicker } from 'lib/common/components/Input';
import Text from 'lib/common/components/Text';

import { useAgentPreferencesContext } from '../../../../contexts/AgentPreferenceContext';

import '../styles/create-agent-task.scss';

export default function TaskDateTime({ scheduledDateTime, handleDateTimeChange, invalidDateTimeError }) {
  const { isSoftphone } = useLayout();
  const {
    state: { preferredDateFormat },
  } = useAgentPreferencesContext();

  return (
    <>
      <div className={cx('create-agent-task__date-time', { 'create-agent-task--padding': isSoftphone })}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <DatePicker
            label="Date"
            value={scheduledDateTime}
            onChange={(newValue) => handleDateTimeChange(newValue, 'date')}
            disablePast
            format={preferredDateFormat}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            invalidDateMessage={<></>}
            minDateMessage={<></>}
            error={Boolean(invalidDateTimeError)}
            id="create-task-date-input"
          />
          <TimePicker
            label="Time"
            mask="__:__ _M"
            id="time-picker"
            value={scheduledDateTime}
            onChange={(newValue) => handleDateTimeChange(newValue, 'time')}
            invalidDateMessage={<></>}
            error={Boolean(invalidDateTimeError)}
          />
        </MuiPickersUtilsProvider>
      </div>
      {invalidDateTimeError && (
        <Text color="danger" type="helper" className="mt-10">
          {invalidDateTimeError}
        </Text>
      )}
    </>
  );
}
